import { toast } from 'react-toastify';
import { BannerProps } from './banner.type';
import { BannerNotification } from './banner-notification/BannerNotification';
import style from './banner.module.scss';

export const BANNER_CONTAINER = 'banner';

export const displayBanner = (bannerProps: BannerProps) => {
  toast(({ closeToast }) => <BannerNotification closeBanner={closeToast} banner={bannerProps} />, {
    toastId: bannerProps.bannerId,
    containerId: BANNER_CONTAINER,
    className: style.banner,
    ...bannerProps.bannerOverrides
  });
};

export const closeBanner = (bannerId: string) => {
  toast.dismiss({ id: bannerId, containerId: BANNER_CONTAINER });
};

export const closeAllBanners = () => {
  toast.dismiss({ containerId: BANNER_CONTAINER });
};
